import axios from "axios";

const instance = axios.create({
    baseURL: "http://smartpnt-datasets.com/smart-pnt-dataset-api",//请求的域名  url = baseURL + requestUrl
    // baseURL: "http://localhost:8080/smart-pnt-dataset-api",//请求的域名  url = baseURL + requestUrl
    timeout: 600000,// 请求超时时间
    // headers: { //设置请求头
    //   "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    // },
});

instance.interceptors.request.use(
    (config) => {

        return config;
    },
    (err) => {
        console.log(err);
        return Promise.reject(err);
    }
);


instance.interceptors.response.use(
    (res) => {
        if (res.status === 200) {
            return res.data;
        }
    },
    (err) => {
        if (err.response.status) {
            err.message = `${err.response.status}`;
        }

        return Promise.reject(err); // 在响应错误的时候的逻辑处理
    }
);


export default instance;
